export const FIGMA_BASE_URL: string = import.meta.env.VITE_FIGMA_BASE_URL;
export const FIGMA_API_BASE_URL: string = import.meta.env.VITE_FIGMA_API_BASE_URL;
